import React from 'react';
import { arrayOf, bool, shape } from 'prop-types';
import { List, ListItem } from '@thd-olt-component-react/list';
import { Row } from '@thd-olt-component-react/grid';
import classnames from 'classnames';
import './bullet-list.scss';

const hasLink = (bullet) => {
  const { value } = bullet;
  return ((typeof value !== 'string') ? false : /^(")<br/.test(value));
};

export const BulletList = (props) => {
  const {
    bullets,
    margin,
    isMobile,
    showRichContentsOnly,
    hideRichContents
  } = props;

  const listClasses = classnames('bullet-list', {
    'bullet-list--margin': margin
  });
  if (!bullets?.length) {
    return null;
  }

  return (
    <Row className="bullet-list-wrapper">
      <List className={listClasses}>
        {bullets.map((bullet, bulletIndex) => {
          const bulletClass = classnames({
            'list__item--nobullet': hasLink(bullet) || showRichContentsOnly
          });
          const isString = typeof bullet.value === 'string';
          const imageMatch = isString ? bullet.value.match(/(http(s?):)([/|.|\w|\s|(|,|)|-])*\.(?:jpg|gif|png)/gi) : '';
          const skipBullet = ((isString && isMobile && imageMatch)
            || (imageMatch && hideRichContents));
          if (skipBullet) {
            return (
              <span
                key={bullet.guid || `bullet-${bulletIndex}`}
                className="list__item--nopadding"
                data-testid="list-item-no-padding"
              />
            );
          }
          return (
            <ListItem key={bullet.guid || `bullet-${bulletIndex}`} className={bulletClass}>
              {isString
                // eslint-disable-next-line react/no-danger
                ? <span dangerouslySetInnerHTML={{ __html: bullet.value.replace(/^"*(.*)"$/, '$1') }} />
                : bullet.value}
            </ListItem>
          );
        })}
      </List>
    </Row>
  );
};

BulletList.displayName = 'BulletList';

BulletList.propTypes = {
  bullets: arrayOf(shape({})).isRequired,
  margin: bool,
  isMobile: bool,
  showRichContentsOnly: bool,
  hideRichContents: bool
};

BulletList.defaultProps = {
  margin: false,
  isMobile: false,
  showRichContentsOnly: false,
  hideRichContents: false
};
